import { DDMMMYYYYHHmm } from 'helpers/dateHelper';
import moment from 'moment';
import {
  CLEAR_CALCULATED_OT_HOUR,
  SET_CALCULATED_OT_HOUR,
  SET_PRE_OT_AVAILABLE_DATE_LIST,
  SET_PRE_OT_ELIGIBLE_DATA,
  SET_SUBMIT_PRE_OVERTIME_REQUEST_INITIAL_STATE,
  SUBMIT_PRE_OVERTIME_REQUEST_ERROR,
  SUBMIT_PRE_OVERTIME_REQUEST_PENDING,
  SUBMIT_PRE_OVERTIME_REQUEST_SUCCESS,
  SET_SELECTED_PRE_OT_DATE_DETAILS,
} from './constants';

const INIT_STATE = {
  canSubmitPreOTRequest: 0,
  availableDateList: [],
  otHours: '',
  totalHours: '',
  savePreOverTimeRequestStatus: '',
  savePreOverTimeRequestErrorMessages: '',
  selectedPreOTDateDetails: '',
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case SET_PRE_OT_ELIGIBLE_DATA: {
      const { respondStatus } = action.payload;
      return {
        ...localState,
        canSubmitPreOTRequest: respondStatus,
      };
    }
    case SET_PRE_OT_AVAILABLE_DATE_LIST: {
      return {
        ...localState,
        availableDateList: action.payload,
      };
    }
    case SET_CALCULATED_OT_HOUR: {
      const { otHours, totalHours } = action.payload;
      return {
        ...localState,
        otHours,
        totalHours,
      };
    }
    case CLEAR_CALCULATED_OT_HOUR: {
      return {
        ...localState,
        otHours: '',
        totalHours: '',
      };
    }
    case SET_SUBMIT_PRE_OVERTIME_REQUEST_INITIAL_STATE: {
      return {
        ...localState,
        savePreOverTimeRequestStatus: '',
        savePreOverTimeRequestErrorMessages: '',
      };
    }
    case SUBMIT_PRE_OVERTIME_REQUEST_PENDING: {
      return {
        ...localState,
        savePreOverTimeRequestStatus: 'PENDING',
        savePreOverTimeRequestErrorMessages: '',
      };
    }
    case SUBMIT_PRE_OVERTIME_REQUEST_SUCCESS: {
      return {
        ...localState,
        savePreOverTimeRequestStatus: 'SUCCESS',
      };
    }
    case SUBMIT_PRE_OVERTIME_REQUEST_ERROR: {
      return {
        ...localState,
        savePreOverTimeRequestStatus: 'ERROR',
        savePreOverTimeRequestErrorMessages: action.payload,
      };
    }
    case SET_SELECTED_PRE_OT_DATE_DETAILS: {
      const { minOTIn, maxOTIn, minOTOut, maxOTOut } = action.payload;
      return {
        ...localState,
        selectedPreOTDateDetails: {
          ...action.payload,
          minOTIn: minOTIn && new Date(moment(minOTIn).format(DDMMMYYYYHHmm)),
          maxOTIn: maxOTIn && new Date(moment(maxOTIn).format(DDMMMYYYYHHmm)),
          minOTOut:
            minOTOut && new Date(moment(minOTOut).format(DDMMMYYYYHHmm)),
          maxOTOut:
            maxOTOut && new Date(moment(maxOTOut).format(DDMMMYYYYHHmm)),
        },
      };
    }
    default:
      return { ...localState };
  }
};
